import React from "react";
import { Link } from "react-router-dom";
import TableCell from "@material-ui/core/TableCell";
import numberFormatter from "utils/numberFormatter";
import LoanTableOptionsMenu from "components/Global/OptionsMenu/LoanTable/LoanTableOptionsMenu";

const LenderPassedLoanTableColumns = [
  {
    id: "4f764785-498c-11e9-a5f4-0242ac120002",
    isBaseColumn: true,
    dataField: "loanProvider.name",
    numeric: false,
    label: "Lender",
    Cell: ({ record, callbacks }) => (
      <TableCell>
        {(
          <Link to={`/loan/${callbacks.getDealId()}/${record.id}`}>
            {record["loanProvider.name"] || "Lender Not Selected"}
          </Link>
        ) || "\u2014"}
      </TableCell>
    )
  },
  {
    id: "52d43bad-498c-11e9-a5f4-0242ac120002",
    isBaseColumn: false,
    dataField: "passReason.name",
    numeric: false,
    label: "Pass Reason",
    Cell: ({ record }) => (
      <TableCell>{record["passReason.name"] || "\u2014"}</TableCell>
    )
  },
  {
    id: "55cb75fa-498c-11e9-a5f4-0242ac120002",
    isBaseColumn: false,
    dataField: "passComment",
    numeric: false,
    label: "Comment",
    Cell: ({ record }) => (
      <TableCell>{record.passComment || "\u2014"}</TableCell>
    )
  },
  {
    id: "menu",
    isBaseColumn: true,
    dataField: null,
    layoutOrder: 999,
    numeric: false,
    Cell: ({ record }) => (
      <TableCell className="loansList_Menu" key="menu">
        <LoanTableOptionsMenu
          id={record.id}
          tableName={"LenderPassedLoanTableColumns"}
        />
      </TableCell>
    )
  }
];

export default LenderPassedLoanTableColumns;
